import request from '@/common/request'
import { AtributoMarketplace, CanalVendaMarketplace, CategoriaGlobalMarketplace, ConfiguracoesMarketplace, ImportacaoArquivoConfiguracao, Page, PedidoMarketplace, PedidoMarketplaceDetalhado, ProdutoMarketplace } from '@/models'
import { AxiosRequestConfig } from 'axios'

export const findAll = async (lojaId: string, params: any, config?: AxiosRequestConfig): Promise<Page<ProdutoMarketplace>> =>
	request.get(`/marketplace/${lojaId}/produtos`, {params: {...params, ...config} })

export const findConfiguracoesPorLoja = async (lojaId: string): Promise<ConfiguracoesMarketplace> =>
	request.get(`/marketplace/${lojaId}/configuracoes`)

export const updateConfiguracao = async (configuracao: ConfiguracoesMarketplace): Promise<ConfiguracoesMarketplace> =>
	request.post(`/marketplace/configuracoes`, configuracao)

export const importarArquivoConfiguracao = async (importacaoArquivoConfiguracao: ImportacaoArquivoConfiguracao): Promise<Date> =>
	request.post(`/marketplace/configuracoes/importacao`, importacaoArquivoConfiguracao)

export const validarTokenParaLogin = async (configuracao: ConfiguracoesMarketplace): Promise<ConfiguracoesMarketplace> =>
	request.post(`/marketplace/configuracoes/login`, configuracao)

export const validarRefreshToken = async (configuracaoId: string, refreshToken: string): Promise<void> =>
	request.post(`/marketplace/configuracoes/${configuracaoId}/refreshtoken`, {refreshToken: refreshToken})

export const findAllAtributos = async (params: any, config?: AxiosRequestConfig): Promise<Page<AtributoMarketplace>> =>
	request.get(`/marketplace/atributos`, {params: {...params, ...config} })

export const findAllCategoriasGlobais = async (params: any, config?: AxiosRequestConfig): Promise<Page<CategoriaGlobalMarketplace>> =>
	request.get(`/marketplace/categorias-globais`, {params: {...params, ...config} })

export const findAllCanaisDeVenda = async (params: any, config?: AxiosRequestConfig): Promise<Page<CanalVendaMarketplace>> =>
	request.get(`/marketplace/canais-venda`, {params: {...params, ...config} })

export const getProduto = async (produtoId: string): Promise<ProdutoMarketplace> =>
	request.get(`/marketplace/produtos/${produtoId}`)

export const createProduto = async (produto: ProdutoMarketplace): Promise<ProdutoMarketplace> =>
	request.post(`/marketplace/produtos`, produto)

export const updateProduto = async (produto: ProdutoMarketplace): Promise<ProdutoMarketplace> =>
	request.put(`/marketplace/produtos/${produto.id}`, produto)

export const integrarProdutos = async (lojaId: string): Promise<void> =>
	request.post(`/marketplace/${lojaId}/produtos/integrar`)

export const atualizarSincronizacaoProduto = async (produtoId: string, sincronizar: boolean): Promise<void> =>
	request.put(`/marketplace/produtos/${produtoId}/sincronizacao?sincronizar=${sincronizar}`)

export const validaProdutoExistente = async (produtoId: string, lojaId: string): Promise<boolean> =>
	request.get(`/marketplace/${lojaId}/produtos/exists?produtoId=${produtoId}`)

export const findAllPedidos = async (lojaId: string, params: any, config?: AxiosRequestConfig): Promise<Page<PedidoMarketplace>> =>
	request.get(`/marketplace/pedidos/${lojaId}`, {params: {...params, ...config} })

export const integrarPedidos = async (lojaId: string): Promise<void> =>
	request.post(`/marketplace/pedidos/${lojaId}/integrar`)

export const findPedidoByVendaId = async (vendaId: string): Promise<PedidoMarketplaceDetalhado> =>
	request.get(`/marketplace/pedidos/por-venda/${vendaId}`)